import React from "react";
import { ArrowLeft, CornerUpLeft, Copy, Forward, Pencil, Trash2, Flag, Smile, Star } from "lucide-react";

const BTN = "h-10 w-10 grid place-items-center rounded-full hover:bg-[color:var(--yalola-surface-alt)] transition-colors shrink-0";

// WhatsApp-style top selection toolbar (multi-select): react/reply/copy/edit/report/star act on a
// single selection; forward/delete act on the whole set.
export const SelectionToolbar = ({ selCount, single, singleText, singleCanEdit, singleMine, canDeleteAll, onClear, onReply, onCopy, onForward, onEdit, onDelete, onReport, onReactOpen, onStar, starLabel, hint }) => {
  if (selCount <= 0) return null;
  return (
    <div
      className="absolute inset-x-0 top-0 z-[82] flex items-center gap-1 px-2 pb-2.5 border-b bg-white"
      style={{ borderColor: "var(--yalola-border)", paddingTop: "calc(0.625rem + var(--sa-top))" }}
      data-testid="chat-selection-toolbar"
    >
      <button onClick={onClear} className={BTN} style={{ color: "var(--yalola-text)" }} data-testid="chat-selection-close"><ArrowLeft size={22} /></button>
      <span className="text-lg font-bold px-1" data-testid="chat-selection-count">{selCount}</span>
      {selCount === 1 && hint && (
        <span className="text-[11px] leading-tight truncate min-w-0" style={{ color: "var(--yalola-text-muted)" }} data-testid="chat-selection-hint">{hint}</span>
      )}
      <div className="flex-1" />
      {single && (
        <button onClick={() => onReactOpen(single)} className={BTN} style={{ color: "var(--yalola-accent, #E0A63C)" }} data-testid={`chat-react-btn-${single.id}`}><Smile size={20} /></button>
      )}
      {single && (
        <button onClick={() => onReply(single)} className={BTN} style={{ color: "var(--yalola-primary)" }} data-testid={`reply-btn-${single.id}`}><CornerUpLeft size={20} /></button>
      )}
      {single && singleText && (
        <button onClick={onCopy} className={BTN} style={{ color: "var(--yalola-text-muted)" }} data-testid={`chat-copy-btn-${single.id}`}><Copy size={19} /></button>
      )}
      {single && onStar && !single.pending && !single.failed && (
        <button onClick={() => onStar(single)} className={BTN} style={{ color: "#E0A63C" }} title={starLabel} aria-label={starLabel} data-testid={`chat-star-btn-${single.id}`} data-starred={single.starred ? "1" : "0"}><Star size={19} fill={single.starred ? "#E0A63C" : "none"} /></button>
      )}
      <button onClick={onForward} className={BTN} style={{ color: "var(--yalola-text-muted)" }} data-testid={single ? `chat-forward-btn-${single.id}` : "chat-forward-selected"}><Forward size={20} /></button>
      {single && singleCanEdit && (
        <button onClick={() => onEdit(single)} className={BTN} style={{ color: "var(--yalola-accent, #E0A63C)" }} data-testid={`chat-edit-btn-${single.id}`}><Pencil size={18} /></button>
      )}
      {canDeleteAll && (
        <button onClick={onDelete} className={`${BTN} text-red-600`} data-testid={single ? `chat-delete-btn-${single.id}` : "chat-delete-selected"}><Trash2 size={19} /></button>
      )}
      {single && !singleMine && (
        <button onClick={() => onReport(single)} className={`${BTN} text-red-600`} data-testid={`chat-report-btn-${single.id}`}><Flag size={18} /></button>
      )}
    </div>
  );
};
